<template>
  <button class="w-6 h-6 rounded bg-arrow-left transition-all hover:bg-gray-100" v-tooltip="'뒤로가기'" @click="$emit('click')" />
</template>

<script>
export default {
  name: 'GrmBackBtn',
}
</script>
